<template>
  <div
    class="lead-history"
    :class="{ 'lead-history--expanded': expanded }"
  >
    <BasePaneTray
      context="leadHistoryContext"
      :isOpen="isOpen"
    >
      <template #headerPlus>
        <div class="lead-history__header">
          <h2
            v-if="heading"
            class="lead-history__header__heading"
          >
            {{ heading }}
          </h2>

          <h4
            v-if="subheading"
            class="lead-history__header__subheading"
            v-html="subheading"
          />
        </div>
      </template>

      <template #body>
        <div class="lead-history__body">
          <div class="lead-history__content-block lead-history__content-block--chat">
            <PartialLeadHistoryChat :leadId="leadId"/>
          </div>

          <div class="lead-history__content-block lead-history__content-block--feeling">
            <PartialLeadHistoryFeeling :leadId="leadId"/>
          </div>

          <div class="lead-history__content-block lead-history__content-block--csat">
            <PartialLeadHistoryCsat
              :leadId="leadId"
              :historyId="historyId"
            />
          </div>
        </div>
      </template>
    </BasePaneTray>
  </div>
</template>

<script>
import BasePaneTray from '@/components/base/BasePaneTray'
import PartialLeadHistoryChat from '@/components/partials/PartialLeadHistoryChat'
import PartialLeadHistoryFeeling from '@/components/partials/PartialLeadHistoryFeeling'
import PartialLeadHistoryCsat from '@/components/partials/PartialLeadHistoryCsat'

export default {
  name: 'CommonLeadHistory',

  components: {
    BasePaneTray,
    PartialLeadHistoryChat,
    PartialLeadHistoryFeeling,
    PartialLeadHistoryCsat
  },

  props: {
    isOpen: Boolean,
    heading: String,
    subheading: String,
    leadId: Number,
    historyId: Number
  },

  data () {
    return {
      expanded: false
    }
  },

  mounted () {
    this.$root.$on('pane-tray-expanded', this.updateExpanded)
  },

  methods: {
    updateExpanded (expanded) {
      this.expanded = expanded
    }
  }
}
</script>

<style lang="scss" scoped>
.lead-history {
  $border: 2px solid nth($colors-custom, 4);

  &--expanded & {
    &__body {
      grid-template: {
        columns: 1fr 1fr 300px;
        rows: auto 1fr;
        areas:
          'chat chat feeling'
          'chat chat csat';
      }
      column-gap: 30px;
    }

    &__content-block {
      &:not(:first-child) {
        border-top: 0;
      }

      &:last-child {
        border-top: $border;
      }
    }
  }

  &__header {
    &__heading {
      font: {
        weight: 700;
        size: 16px;
      }
      line-height: 120%;
    }

    &__subheading {
      margin-top: 5px;
      font-size: 12px;
      line-height: 140%;

      /deep/ {
        div {
          &:not(:first-child) {
            color: nth($colors-custom, 15);
          }
        }
      }
    }
  }

  &__body {
    display: grid;
    height: 100%;
    grid-template: {
      columns: 1fr;
      rows: minmax(200px, 1fr) auto;
      areas:
        'chat'
        'feeling'
        'csat';
    }
  }

  &__content-block {
    padding: 20px 0;
    overflow: hidden;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
    }

    &:not(:first-child) {
      border-top: $border;
    }

    &--chat {
      grid-area: chat;
    }

    &--feeling {
      grid-area: feeling;
    }

    &--csat {
      grid-area: csat;
    }
  }
}
</style>
